export const TRAINING_EMPTY_VALUE = '—';
